import { Route, Routes } from "react-router-dom";
import NotFoundPage from "Layouts/NotFoundPage";
import { AppRoutes } from './AppRoutes'
import WithUserContext from 'Hoc/WithUserContext';
import IPermissionContextState from 'Models/PermissionContextModel';
import IPathModel from 'Models/PathModel';
import RouteBuilder from 'Utils/RouteBuilder';

const createRouteElements = (props: IProps) => {
    const flat = AppRoutes.flat(2)
    const allRoutes = flat.map((route: IPathModel, index: number) =>
        <Route
            path={RouteBuilder(route)}
            element={<props.context.CheckAccess
                accsess={[]}
                withAccessDeniedPage={true}>
                <route.element />
            </props.context.CheckAccess>}
            key={index} />)
    return allRoutes
}

type IProps = IPermissionContextState

const AppRouter = (props: IProps) => {
    return (
        <Routes>
            {createRouteElements(props)}
            <Route element={NotFoundPage} />
        </Routes>
    )
}


export default WithUserContext(AppRouter);